
// TODO: [SR-2676] remove experiments.crossSellModal2Sections
import { mapGetters } from 'vuex'

import IllustrationDango from '@core/illustrations/IllustrationDango.svg'
import CarouselSkeleton from '@recommendation/components/RecommendedProductsCarousel/CarouselSkeleton.vue'
import RecommendedProductsCarousel from '@recommendation/components/RecommendedProductsCarousel/RecommendedProductsCarousel.vue'
import { logger } from '@recommendation/helpers'
import recommendationAPIClient from '@recommendation/recommendationAPIClient'
import { PRODUCT_SOURCE_TYPE } from '@tracking'

import translations from './RecommendationCrossSell.translations'

const emptyRecommendation = () => ({
  products: [],
  widgetId: [],
})

export default {
  components: {
    CarouselSkeleton,
    IllustrationDango,
    RecommendedProductsCarousel,
  },
  props: {
    listingId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      crossSell: emptyRecommendation(),
      crossSellProtection: emptyRecommendation(),
    }
  },
  async fetch() {
    const recommendationsCalls =
      this.experiments.crossSellModal2Sections ===
      'CrossSellModalWith2SectionsProtectionOtherAccessories'
        ? [
            this.fetchRecommendation('crossSellTwo'),
            this.fetchRecommendation('crossSellProtection'),
          ]
        : [this.fetchRecommendation('crossSellOne')]

    const [crossSell, crossSellProtection] = await Promise.allSettled(
      recommendationsCalls,
    ).then((results) =>
      results.map(({ status, value, reason }) => {
        if (status === 'fulfilled') return value
        logger.info(new Error(reason), {
          component: { name: 'RecommendationCrossSell', props: this.$props },
          routeName: this.$route.name,
        })

        return emptyRecommendation()
      }),
    )
    this.crossSell = crossSell
    this.crossSellProtection = crossSellProtection ?? emptyRecommendation()
  },
  computed: {
    // TODO: [SR-2676] remove experiments.crossSellModal2Sections
    ...mapGetters({
      experiments: 'flags/getExperiments',
    }),
    translations: () => translations,
    trackingList: () => PRODUCT_SOURCE_TYPE.CROSS_SELL_MODAL,
    trackingListCrossSellProtection() {
      // cross sell modal 1
      return `${PRODUCT_SOURCE_TYPE.CROSS_SELL_MODAL} 1`
    },
    trackingListcrossSell() {
      // TODO: [SR-2676] remove experiments.crossSellModal2Sections
      // cross sell modal 2
      if (
        this.experiments.crossSellModal2Sections ===
        'CrossSellModalWith2SectionsProtectionOtherAccessories'
      ) {
        return `${PRODUCT_SOURCE_TYPE.CROSS_SELL_MODAL} 2`
      }

      // cross sell modal
      return PRODUCT_SOURCE_TYPE.CROSS_SELL_MODAL
    },
    scopeId() {
      return String(this.listingId)
    },
    shouldDisplayErrorState() {
      return (
        !this.$fetchState.pending &&
        !this.isCrossSellNotEmpty &&
        !this.isCrossSellProtectionNotEmpty
      )
    },
    isCrossSellNotEmpty() {
      return this.crossSell.products.length > 0
    },
    isCrossSellProtectionNotEmpty() {
      return this.crossSellProtection.products.length > 0
    },
    recoInGrade() {
      return this.experiments.recoInGrade
    },
  },
  watch: {
    scopeId(newScopeId, previousScopeId) {
      if (newScopeId !== previousScopeId) {
        this.$fetch()
      }
    },
  },
  methods: {
    addToCart({ listingId }) {
      this.crossSell.products = this.crossSell.products.filter(
        (p) => p.listing.id !== listingId,
      )
      this.crossSellProtection.products =
        this.crossSellProtection.products.filter(
          (p) => p.listing.id !== listingId,
        )
    },

    fetchRecommendation(category) {
      return recommendationAPIClient((request) =>
        this.$store.dispatch('http/request', request),
      ).getRecommendedProducts({
        category,
        limit: 12,
        scope: 'addToCart',
        scopeId: this.scopeId,
        recoInGrade: this.recoInGrade,
      })
    },
  },
}
